import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Lucas M.",
    role: "Streamer FPS",
    text: "Build clé en main impeccable, câblage à tomber et le PC ne dépasse pas 65°C en charge. Le prix annoncé a été respecté à l'euro près.",
    rating: 5,
  },
  {
    name: "Sophie R.",
    role: "Graphiste freelance",
    text: "J'avais mes composants, ZF a tout monté en 24h. Tests faits, Windows installé, RAS. Très pro et hyper sympa.",
    rating: 5,
  },
  {
    name: "Karim B.",
    role: "Joueur 1440p",
    text: "Devis détaillé reçu le soir-même, livraison à domicile une semaine après. Machine silencieuse, ça change tout.",
    rating: 5,
  },
  {
    name: "Antoine L.",
    role: "Étudiant",
    text: "Petit budget mais énorme conseil. On a optimisé chaque ligne du devis. Le PC tourne tous mes jeux en 1080p ultra.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="absolute inset-0 bg-radial-violet opacity-40 pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // Témoignages
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Ils ont fait confiance.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="reveal relative rounded-2xl border border-white/10 bg-zinc-900/50 backdrop-blur p-6 hover:border-violet-400/40 transition-all hover:-translate-y-1"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <Quote className="h-6 w-6 text-violet-400/60" />
              <blockquote className="mt-3 text-sm leading-relaxed text-zinc-300">
                "{t.text}"
              </blockquote>
              <div className="mt-5 flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star
                    key={idx}
                    className="h-3.5 w-3.5 fill-violet-400 text-violet-400"
                  />
                ))}
              </div>
              <figcaption className="mt-3 text-xs">
                <span className="font-semibold text-white">{t.name}</span>
                <span className="text-zinc-500"> · {t.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
